import { logoutUser } from "./userService";
import Cookies from 'js-cookie';
const axios = require("axios");

// Normalizes an axios failure into a rejectable value (the response when
// available, else the error). Services should `.catch(e => { throw
// getRejectableError(e); })` so failures REJECT instead of resolving — letting
// callers distinguish success from failure. See TECH_DEBT.md (Phase 3).
export function getRejectableError(error) {
  return error?.response || error || new Error("Unknown axios error");
}

//base URL.
let instance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL
});

// Alter defaults after instance has been created
instance.defaults.headers.common["language"] = "en";

// handle logout session on deactivate or expired
const handleLogoutSession = (error) => {
  try {
    // Clear local and session storage
    localStorage.clear();

    // Remove all cookies (try multiple domain variants)
    const cookies = Object.keys(Cookies.get());
    const hostname = window.location.hostname;
    const domains = [hostname];

    // Add top-level domain variant if applicable
    const parts = hostname.split(".");
    if (parts.length > 2) {
      domains.push(parts.slice(-2).join(".")); // e.g. stage.example.com -> example.com
    }

    cookies.forEach((cookieName) => {
      domains.forEach((domain) => {
        Cookies.remove(cookieName, {
          path: "/",
          domain,
          secure: window.location.protocol === "https:",
        });
      });
    });

    // Figure out where to redirect
    const message = error?.response?.data?.message;
    let path = "/login?reason=expired";
    if (message === "User Account Deactivated") {
      path = "/login?reason=deactivated";
    }

    // Optional: If backend returns a redirect URL
    const returnToUrl = error?.response?.data?.returnToUrl || "";

    // Redirect based on environment
    if (
      process.env.NODE_ENV === "production" ||
      process.env.NODE_ENV === "staging"
    ) {
      window.location.href = returnToUrl + path;
    } else {
      window.location.href = path;
    }
  } catch (logoutError) {
    console.error("Error while handling logout:", logoutError);
    window.location.href = "/login?reason=expired";
  }
};
//request interceptor
instance.interceptors.request.use(
    async function (config) {
        // Do something before request is sent
        try {
            config.headers.language = getLanguage();
            const token = localStorage.getItem("token"); // Fetch token
            if (token) {
                config.headers.Authorization = `Bearer ${token}`; // Add token to headers
            }
        } catch (e) {
            console.error("localstorage not found---->>>", e);
        }

        return config;
    },
    function (error) {
        // Do something with request error
      return Promise.reject(getRejectableError(error));
    }
);
//response interceptor
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        // Do something with response error
        if (error && error.response && error.response.status === 401) {
            let hasToken = false;
            try {
                hasToken = Boolean(localStorage.getItem("token"));
            } catch (storageError) {
                hasToken = false;
            }
            const onLoginPage = window.location.pathname.startsWith("/login");
            // Only force a logout-redirect when an *authenticated* session is
            // rejected. With no token, or while already on /login, a 401 is
            // expected for pre-login calls (e.g. the public /settings request);
            // redirecting to /login there reload-loops the page.
            if (hasToken && !onLoginPage) {
                console.error("unauthorized, logging out ...", error.response);
                try {
                    localStorage.removeItem("token");
                } catch (storageError) {
                    // ignore storage errors; still redirect to clear the session
                }
                window.location.href = "/login";
            }
        }
        if (error && error.response && error.response.status === 403 &&
            (error.response.data.message === "User Account Deactivated" || error.response.data.message === "User Account Expired" || error.response.data.message === "Tenant License Expired" || error.response.data.message === "Tenant License Not Approved")) {
            
            // Skip logout API call and session handling for login requests
            if (error.config?.url?.includes('/auth/login')) {
              return Promise.reject(getRejectableError(error));
            }
            // if web then logout.
            console.error("unauthorized user Access, logging out ...", error.response);


            // window.location.href = "/login";
            logoutUser().then((response) => {
                if (response?.status === 200) {
                    handleLogoutSession(error)
                }
            })
            .catch((logoutError) => {
                // Even if logout API fails, clear local storage and redirect
                console.error("Logout API failed:", logoutError);
                handleLogoutSession(error)
            })

        }
        return Promise.reject(getRejectableError(error));
    }
);

function getLanguage() {
    return localStorage.getItem("language");
}

export default instance;
